export default __webpack_public_path__ + "static/media/card-dinersclub.277702de.svg";